import { ProgramRawResponse } from "./../../modules/programs/services/usePrograms";

export const findProgramIdByCategoryAndDescription = (
  program: ProgramRawResponse,
  programDescription: string,
  categoryDescription: string,
) => {
  return program.categories.find((category) => {
    return program.description === programDescription && category.category === categoryDescription;
  });
};
